import { Box, Button, MenuItem, TextField } from "@mui/material";
import { CLAIM_OPTIONS, DATE_MODES, MODULE_OPTIONS, MONTHS, yearsForFilter } from "./plConstants";

const field = { minWidth: 150 };

// Controlled filter bar. Parent owns the filter state; this only renders + emits patches.
const ProfitLossFilters = ({ filters, onChange, onReset }) => {
  const set = (key) => (e) => onChange({ [key]: e.target.value });

  return (
    <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", alignItems: "center", mb: 2 }}>
      <TextField
        select
        size="small"
        label="Date range"
        sx={field}
        value={filters.dateMode}
        onChange={set("dateMode")}
      >
        {DATE_MODES.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </TextField>

      {(filters.dateMode === "YEAR" || filters.dateMode === "MONTH") && (
        <TextField
          select
          size="small"
          label="Year"
          sx={field}
          value={filters.year}
          onChange={set("year")}
        >
          {yearsForFilter.map((y) => (
            <MenuItem key={y} value={y}>
              {y}
            </MenuItem>
          ))}
        </TextField>
      )}

      {filters.dateMode === "MONTH" && (
        <TextField
          select
          size="small"
          label="Month"
          sx={field}
          value={filters.month}
          onChange={set("month")}
        >
          {MONTHS.map((m) => (
            <MenuItem key={m.value} value={m.value}>
              {m.label}
            </MenuItem>
          ))}
        </TextField>
      )}

      {filters.dateMode === "CUSTOM" && (
        <>
          <TextField
            size="small"
            label="From"
            type="date"
            sx={field}
            InputLabelProps={{ shrink: true }}
            value={filters.from}
            onChange={set("from")}
          />
          <TextField
            size="small"
            label="To"
            type="date"
            sx={field}
            InputLabelProps={{ shrink: true }}
            value={filters.to}
            onChange={set("to")}
          />
        </>
      )}

      <TextField
        select
        size="small"
        label="Module"
        sx={field}
        value={filters.module}
        onChange={set("module")}
      >
        {MODULE_OPTIONS.map((o) => (
          <MenuItem key={o.label} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        size="small"
        label="Claim status"
        sx={field}
        value={filters.claimFilter}
        onChange={set("claimFilter")}
      >
        {CLAIM_OPTIONS.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        size="small"
        label="Case officer"
        sx={field}
        value={filters.caseOfficer}
        onChange={set("caseOfficer")}
      />

      <TextField
        size="small"
        label="Search client"
        sx={{ minWidth: 200 }}
        value={filters.search}
        onChange={set("search")}
      />

      <Button variant="text" size="small" onClick={onReset}>
        Reset
      </Button>
    </Box>
  );
};

export default ProfitLossFilters;
